export const EventInsert = {
  name: "insert",
  component: "InsertPanel",
  layout: "insert-base",
  mode: "visible",
  showOn: true,
};
